module.exports = __webpack_public_path__ + "img/Katzenbabies.a5fc5160.jpg";